import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <section id="contact" className="py-24 bg-charcoal-900 relative overflow-hidden" data-id="element-75">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-900 transform skew-x-12 translate-x-32 hidden lg:block" data-id="element-76"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-78">
          <div data-id="element-79">
            <h2 className="text-4xl md:text-5xl font-serif-display font-bold text-white mb-6 leading-tight" data-id="element-80">
              Ready for Your Next Board Seat or Executive Opportunity?
            </h2>
            <p className="text-gray-300 text-lg mb-10 leading-relaxed" data-id="element-81">
              Schedule a confidential consultation to discuss your career
              trajectory and how we can position you for the highest levels of
              corporate leadership.
            </p>

            <div className="space-y-6 text-gray-300" data-id="element-82">
              <div className="flex items-center" data-id="element-83">
                <div className="w-12 h-12 bg-navy-800 rounded-sm flex items-center justify-center mr-4 border border-navy-700" data-id="element-84">
                  <span className="text-gold font-bold" data-id="element-85">01</span>
                </div>
                <div data-id="element-86">
                  <h4 className="text-white font-bold" data-id="element-87">Submit Inquiry</h4>
                  <p className="text-sm" data-id="element-88">
                    Provide your current details and goals.
                  </p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-89">
                <div className="w-12 h-12 bg-navy-800 rounded-sm flex items-center justify-center mr-4 border border-navy-700" data-id="element-90">
                  <span className="text-gold font-bold" data-id="element-91">02</span>
                </div>
                <div data-id="element-92">
                  <h4 className="text-white font-bold" data-id="element-93">Executive Review</h4>
                  <p className="text-sm" data-id="element-94">Our team reviews your background.</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-95">
                <div className="w-12 h-12 bg-navy-800 rounded-sm flex items-center justify-center mr-4 border border-navy-700" data-id="element-96">
                  <span className="text-gold font-bold" data-id="element-97">03</span>
                </div>
                <div data-id="element-98">
                  <h4 className="text-white font-bold" data-id="element-99">Strategy Session</h4>
                  <p className="text-sm" data-id="element-100">We discuss your branding strategy.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-sm shadow-2xl" data-id="element-101">
            {formState === 'success' ? <div className="text-center py-12" data-id="element-102">
                <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" data-id="element-103" />
                <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-104">
                  Inquiry Received
                </h3>
                <p className="text-gray-600" data-id="element-105">
                  Thank you for reaching out. A senior branding strategist will
                  contact you within 24 hours to schedule your consultation.
                </p>
                <button onClick={() => setFormState('idle')} className="mt-8 text-gold font-semibold hover:text-gold-600 transition-colors" data-id="element-106">
                  Submit another inquiry
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-107">
                <h3 className="text-2xl font-bold text-navy-900 mb-6 font-serif-display" data-id="element-108">
                  Request Consultation
                </h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-109">
                  <div data-id="element-110">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-111">
                      First Name
                    </label>
                    <input type="text" id="firstName" required className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-gold focus:border-gold outline-none transition-all" data-id="element-112" />
                  </div>
                  <div data-id="element-113">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-114">
                      Last Name
                    </label>
                    <input type="text" id="lastName" required className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-gold focus:border-gold outline-none transition-all" data-id="element-115" />
                  </div>
                </div>

                <div data-id="element-116">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-117">
                    Corporate Email
                  </label>
                  <input type="email" id="email" required className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-gold focus:border-gold outline-none transition-all" data-id="element-118" />
                </div>

                <div data-id="element-119">
                  <label htmlFor="target" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-120">
                    Primary Goal
                  </label>
                  <select id="target" className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-gold focus:border-gold outline-none transition-all bg-white" data-id="element-121">
                    <option data-id="element-122">Board Appointment</option>
                    <option data-id="element-123">C-Suite Transition</option>
                    <option data-id="element-124">Executive Promotion</option>
                    <option data-id="element-125">LinkedIn Optimization</option>
                    <option data-id="element-126">Other</option>
                  </select>
                </div>

                <div data-id="element-127">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-128">
                    Brief Background (Optional)
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-gold focus:border-gold outline-none transition-all resize-none" data-id="element-129"></textarea>
                </div>

                <button type="submit" disabled={formState === 'submitting'} className="w-full bg-navy-900 hover:bg-navy-800 text-white px-6 py-4 rounded-sm font-semibold text-lg transition-all duration-300 flex items-center justify-center group disabled:opacity-70" data-id="element-130">
                  {formState === 'submitting' ? 'Processing...' : 'Get Started Today'}
                  {formState === 'idle' && <Send className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-131" />}
                </button>
                <p className="text-xs text-gray-500 text-center mt-4" data-id="element-132">
                  All inquiries are strictly confidential.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}